import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { hot } from 'react-hot-loader';
import { withRouter } from 'react-router';
import { compose } from 'ramda';

import { AuthOverlay } from './authOverlay.component';
import { AuthActions, selectIsModalVisible } from '../../../modules/auth';
import { AnalyticsActions } from '../../../modules/analytics';

const mapStateToProps = createStructuredSelector({
  visibleModal: selectIsModalVisible,
});

export const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      hide: AuthActions.hideModal,
      show: AuthActions.showModal,
      logGTMEvent: AnalyticsActions.logGTMEvent,
    },
    dispatch
  );

export default compose(
  hot(module),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withRouter
)(AuthOverlay);
